module.exports = __webpack_public_path__ + "img/1.fbc02f9b.png";